import "../../styles/reset.less";
import "../../styles/global.less";
import "./industry-solution.less";
import $ from "jquery";


$(document).ready(function () {
  $("#topHeader").css(
    "background-color",
    "rgba(1, 84, 155, 1)"
  );

});

